import { useEffect, useRef, useState } from "react";
import "../assets/scss/infinitetext.scss";

const InfiniteText = ({ token }) => {
  const [messages, setMessages] = useState("");
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem("authUser") || "null")
  );

  const trackRef = useRef(null);
  const [duration, setDuration] = useState(20);

  useEffect(() => {
    const updateUser = () => {
      const updatedUser = JSON.parse(
        localStorage.getItem("authUser") || "null"
      );

      setMessages("");
      setLoading(true);
      setUser(updatedUser);
    };

    window.addEventListener("authUserChanged", updateUser);

    return () => {
      window.removeEventListener("authUserChanged", updateUser);
    };
  }, []);

  useEffect(() => {
    if (!token || !user?.Id) {
      setMessages("");
      setLoading(false);
      return;
    }

    const isAdmin = user?.Role === "Student" ? 0 : 1;
    const userId = user.Id;
    let cancelled = false;

    const getMessages = async () => {
      try {
        const res = await fetch(
          `https://api.kunalsdrumclass.com/api/GetLastNotification?userId=${userId}&isAdmin=${isAdmin}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!res.ok) {
          throw new Error(`Request failed: ${res.status}`);
        }

        const result = await res.json();

        if (!cancelled) {
          setMessages(result?.recordsets?.[0]?.[0]?.Message || "");
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching messages:", error);
          setMessages("");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    setLoading(true);
    getMessages();

    const interval = setInterval(getMessages, 3000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [token, user?.Id, user?.Role]);

  useEffect(() => {
    if (trackRef.current) {
      const width = trackRef.current.scrollWidth / 2;
      const speed = 80;
      setDuration(width / speed);
    }
  }, [messages]);

  if (loading || !messages) return null;

  return (
    <div className="ticker">
      <div
        ref={trackRef}
        className="ticker-track"
        style={{ animationDuration: `${duration}s` }}
      >
        {[0, 1].map((group) => (
          <div
            key={group}
            className="ticker-group"
            aria-hidden={group === 1 ? "true" : undefined}
          >
            {Array(10)
              .fill(messages)
              .map((item, index) => (
                <span key={index} className="ticker-item">
                  “{item}”
                </span>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfiniteText;